// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Organization_titleWrapper__vZu5w","sponsorWrapper":"Organization_sponsorWrapper__L+stE","footer":"Organization_footer__FtYe4","host":"Organization_host__VBGOH"};